import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
// import { useHistory } from "react-router-dom"; // ✅ Import useNavigate
import HeaderTransprent from "../../components/HeaderTransprent";
import Footer from "../../components/Footer";
import ContactForm from "../../ui/ContactForm";
import AllCompnayLogo from "../../ui/AllCompnayLogo";

import Modal24 from "../../ui/Modal24";
import JsonData from "../../JsonData/jsonData.json";
import { FaLinkedin } from "react-icons/fa";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


const Award = ({ loggingIn, questions, user, assessment, ...props }) => {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const [activeTab, setActiveTab] = useState(0);
  const [activeTab2, setActiveTab2] = useState(0);

  const tabTitles = [
    "Happiest Places <br/> to Thrive 2025",
    "Employee Pride<br/> Excellence Award 2025",
    "Emerging Happy <br/>Workplaces 2025"
  ];

  const tabTitles2 = [
    "Most Influencing CHRO Excellence in Happiness and Wellbeing",
    "Exemplary Individual <br/>Contribution",
  ];

  const settingsone = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 6000,
    arrows: false,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }

    ]
  };
  const settingstwo = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 6000,
    arrows: false,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }

    ]
  };
  const settingsthree = {
    dots: false,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: -1,
    autoplay: true,
    speed: 10000,
    arrows: false,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 5,
          slidesToScroll: -1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
          slidesToScroll: -1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: -1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: -1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: -1
        }
      }

    ]

  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="overflow-hidden">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Happiness and Wellbeing Conclave 2025 | A Path to Personal and Professional Growth</title>
          <meta name="description" content="Explore the key takeaways from the Happiness and Wellbeing Conclave 2025. Discover expert insights, strategies, and moments that focused on enhancing mental health and overall wellbeing." />
          <link rel="canonical" href="https://happiestworkplaces.in/#/happiness-and-wellbeing-conclave-2025" />
        </Helmet>

        <section className="bg-[#2196F3]/10 w-full h-auto bg-cover bg-no-repeat bg-right" style={{ backgroundImage: `url('/img/home/hero-bg.webp')`, }}>
          <HeaderTransprent />

          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full gap-10 md:py-20 md:flex-row 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="flex flex-col justify-center w-full h-full pt-10 mx-auto my-auto space-y-6 text-center md:pb-12 md:pt-0 md:text-left">
                <div className="flex items-center">
                  <img data-aos="fade-left" src="/img/award/Logos-2024.svg" alt="re-discover-yourself-using" className="h-56" />
                </div>
                <h1 data-aos="fade-right" className="xl:text-6xl text-5xl leading-[3rem] xl:leading-[3.5rem] font-extrabold textcolor capitalize">Happiness and <br /> Wellbeing  <br /> Conclave 2025</h1>
                <div data-aos="fade-right" className="text-xl font-bold md:text-2xl">
                  <p className="text-[#212121]">1st Feb, 2025  |  Taj Lands End, Mumbai</p>
                </div>
                <div data-aos="fade-right" className="text-base font-semibold md:text-lg">
                  <p className="text-[#212121]">Creating A Thriving Work Culture for Sustained <br />Performance!</p>
                </div>
                {/* <div className="flex flex-row items-center justify-center gap-4 md:justify-start md:items-center">
                  <ButtonPage text="Get Certified" onClick={() => ""} />
                </div> */}
              </div>

              <div className="flex items-center justify-center w-full lg:justify-end">
                <img data-aos="fade-left" src="/img/award/happiest-workplaces-award.webp" alt="re-discover-yourself-using" className="z-0" />
              </div>
            </div>
          </div>
        </section>

        {/* We Offer */}
        <section className="w-full space-y-6 bg-cover" style={{ backgroundImage: `url('/img/assessment/bg-gradient.webp')` }}>
          <div className="w-full h-full bg-white">
            <div className="flex flex-col justify-start w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="text-center pb-12">
                <h1 className="text-xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-semibold text-[#183889]">Organization Winners</h1>
                <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Congratulations</h1>
              </div>
              <div className="flex flex-col items-center justify-center w-full gap-10 lg:gap-10 md:gap-20">
                <div data-aos="fade-right" className=" w-full text-left grid lg:grid-cols-3 grid-cols-1 gap-4 xl:px-44 lg:px-24 px-4">
                  {tabTitles.map((title, index) => (
                    <div
                      key={index}
                      onClick={() => setActiveTab(index)}
                      className={`text-center rounded-md cursor-pointer transition-all duration-150 py-6 px-4 text-lg font-semibold space-y-2 bg-gradient-to-b ${activeTab === index
                        ? "from-[#F8BBD0] to-transparent textcolor"
                        : "from-[#212121]/10 to-white text-[#212121]"
                        }`}
                    >
                      <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
                    </div>
                  ))}
                </div>
              </div>

              {activeTab === 0 && (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 pt-8">
                  {JsonData.companyAwards.slice(0, 15).map((logo, index) => (
                    <div key={index} className="text-center m-4">
                      <img className="w-full" src={logo.src} alt={logo.name} />
                    </div>
                  ))}
                </div>
              )}

              {activeTab === 1 && (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 pt-8">
                  {JsonData.companyAwards.slice(15, 19).map((logo, index) => (
                    <div key={index} className="text-center m-4">
                      <img className="w-full" src={logo.src} alt={logo.name} />
                    </div>
                  ))}
                </div>
              )}

              {activeTab === 2 && (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 pt-8">
                  {JsonData.companyAwards.slice(19, 24).map((logo, index) => (
                    <div key={index} className="text-center m-4">
                      <img className="w-full" src={logo.src} alt={logo.name} />
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </section>

        {/* We Offer 2*/}
        <section className="w-full space-y-6 bg-cover" style={{ backgroundImage: `url('/img/assessment/bg-gradient.webp')` }}>
          <div className="w-full h-full bg-white">
            <div className="flex flex-col justify-start w-full h-full pb-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
              <div className="text-center pb-12">
                <h1 className="text-xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-semibold text-[#183889]">Individuals Winners</h1>
                <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Congratulations</h1>
              </div>
              <div className="flex flex-col items-center justify-center w-full gap-10 lg:gap-10 md:gap-20">
                <div data-aos="fade-right" className="w-full text-left grid lg:grid-cols-2 grid-cols-1 gap-4 xl:px-72 lg:px-36 px-4 mx-auto">
                  {tabTitles2.map((title, index) => (
                    <div
                      key={index}
                      onClick={() => setActiveTab2(index)}
                      className={`text-center rounded-md cursor-pointer transition-all duration-150 py-6 px-4 text-lg font-semibold space-y-2 bg-gradient-to-b ${activeTab2 === index
                        ? "from-[#F8BBD0] to-transparent textcolor"
                        : "from-[#212121]/10 to-white text-[#212121]"
                        }`}
                    >
                      <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
                    </div>
                  ))}
                </div>
              </div>

              {activeTab2 === 0 && (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 pt-8">
                  {JsonData.congrates.slice(0, 7).map((congrates, index) => (
                    <div key={index} className="flex flex-col bg-white">
                      <img alt="" className="object-cover w-full bg-gray-500" src={congrates.src} />
                      <div className="flex flex-col flex-1 p-6 text-center justify-center items-center">
                        <h2 className="text-xl font-bold text-[#212121]">{congrates.name}</h2>
                        <p className="text-sm text-[#212121]">{congrates.designation}</p>
                      </div>
                      <button onClick={() => window.open(congrates.link, "_blank")} className="flex justify-center items-center text-base font-semibold cursor-pointer text-white bg-[#E91E63] hover:bg-[#183889] px-6 py-3 space-x-3">
                        <FaLinkedin className="w-5 h-5 text-white" />
                        <span>LinkedIn</span>
                      </button>
                    </div>
                  ))}
                </div>
              )}

              {activeTab2 === 1 && (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 pt-8">
                  {JsonData.congrates.slice(7, 19).map((congrates, index) => (
                    <div key={index} className="flex flex-col bg-white">
                      <img alt="" className="object-cover w-full bg-gray-500" src={congrates.src} />
                      <div className="flex flex-col flex-1 p-6 text-center justify-center items-center">
                        <h2 className="text-xl font-bold text-[#212121]">{congrates.name}</h2>
                        <p className="text-sm text-[#212121]">{congrates.designation}</p>
                      </div>
                      <button onClick={() => window.open(congrates.link, "_blank")} className="flex justify-center items-center text-base font-semibold cursor-pointer text-white bg-[#E91E63] hover:bg-[#183889] px-6 py-3 space-x-3">
                        <FaLinkedin className="w-5 h-5 text-white" />
                        <span>LinkedIn</span>
                      </button>
                    </div>
                  ))}
                </div>
              )}

            </div>
          </div>
        </section>

        <section className="bg-[#FDE9EF] text-gray-100">
          <div className="flex flex-col justify-start w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="grid lg:gap-16 lg:grid-cols-2 lg:items-center">
              <div className="lg:col-start-2">
                <div className="mt-12 space-y-12">
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <img src="/img/award/honor.svg" alt="" className="w-20 h-20" />
                    </div>
                    <div className="ml-8 text-[#212121]">
                      <h4 className="text-2xl font-bold leading-6">Honor</h4>
                      <p className="mt-4">Your relentless work towards employee happiness and experience through meaningful recognition.</p>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <img src="/img/award/witness.svg" alt="" className="w-20 h-20" />
                    </div>
                    <div className="ml-8 text-[#212121]">
                      <h4 className="text-2xl font-bold leading-6">Witness</h4>
                      <p className="mt-4">The power of wellbeing as you illuminate others and become the guiding force with your transformative stories.</p>
                    </div>
                  </div>
                  <div className="flex">
                    <div className="flex-shrink-0">
                      <img src="/img/award/aspire.svg" alt="" className="w-20 h-20" />
                    </div>
                    <div className="ml-8 text-[#212121]">
                      <h4 className="text-2xl font-bold leading-6">Aspire</h4>
                      <p className="mt-4">Aspire and achieve a harmonious eco-system where happy employees and customers coexist and flourish.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-10 lg:mt-0 lg:col-start-1 lg:row-start-1">
                <div className="space-y-6">
                  <h1 className="text-3xl mb-8 font-bold tracking-tight text-left sm:text-5xl textcolor">Why Happiness and Wellbeing Research!</h1>
                  <p className="text-lg text-[#212121] text-left">
                    The Happiness and Wellbeing Research, in collaboration with ET HR World as the esteemed media partner, is a heartfelt tribute to employers who are passionately taking a step forward to cultivate happy and healthy workspaces. Its aim to recognize organizations that tirelessly strive to enrich workplaces, both emotionally and intellectually.
                  </p>
                  <p className="text-lg text-[#212121] text-left">
                    This initiative aims to celebrate organizations’ endeavors in fostering a healthy culture and offers a platform to showcase their inspiring stories, which have the power to motivate millions.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-6 bgcolor">
          <div className="h-full 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto flex flex-col items-center justify-center p-4 space-y-8 lg:space-y-0 lg:flex-row lg:justify-between">
            <h1 className="text-4xl font-semibold leading-tight text-center lg:text-left text-white">Agenda of the 2025 event</h1>
            <button onClick={openModal} className="px-8 py-3 text-lg font-semibold bg-white uppercase textcolor hover:bg-[#183889] hover:text-white">View Agenda</button>
          </div>
          <Modal24 isOpen={isModalOpen} onClose={closeModal} />
        </section>

        <section>
          <div className="flex flex-col justify-start w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="text-center pb-12">
              <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Esteemed Speakers 2025</h1>
            </div>
            <div className="grid grid-cols-1 gap-x-4 gap-y-8 md:grid-cols-2 lg:grid-cols-4">
              {JsonData.speakers24.map((speakers24, index) => {
                return (
                  <div key={index} className="flex flex-col bg-white">
                    <img alt="" className="object-cover w-full bg-gray-500" src={speakers24.src} />
                    <div className="flex flex-col flex-1 p-6 text-center justify-center items-center">
                      <h2 className="text-xl font-bold text-[#212121]">{speakers24.name}</h2>
                      <p className="text-sm text-[#212121]">{speakers24.designation}</p>
                    </div>
                    <button onClick={() => window.open(speakers24.link, "_blank")} className="flex justify-center items-center text-base font-semibold cursor-pointer text-white bg-[#E91E63] hover:bg-[#183889] hover:text-white px-6 py-3 space-x-3">
                      <FaLinkedin className="w-5 h-5 text-white" />
                      <span>LinkedIn</span>
                    </button>
                  </div>
                );
              })}
            </div>

          </div>
        </section>

        {/* GLIMPSE */}
        <div className="bg-pink-600">
          <div className="flex flex-col justify-start w-full h-full py-20 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="grid lg:grid-cols-3 grid-cols-1 gap-4">
              <div className="text-white font-bold text-6xl flex md:flex-col flex-row justify-start items-start pr-10">
                <div className="flex flex-col space-y-2">
                  <div className="flex">
                    <div className="w-12 h-12 bg-white"></div>
                    <div className="w-5 h-5 bg-white mt-6 ml-4"></div>
                    <div className="w-5 h-5 bg-white"></div>
                  </div>
                  <div className="flex space-x-1">
                    <div className="w-5 h-5 bg-white"></div>
                  </div>
                  <span>GLIMPSE OF</span>
                  <span>SPEAKERS</span>
                  <span>2025</span>
                </div>
              </div>

              <div className="col-span-2 grid md:grid-cols-2 grid-cols-1 gap-4">
                {JsonData.videoLink24.map((videoLink24, index) => {
                  return (
                    <div key={index}>
                      <iframe
                        className="w-full h-64"
                        src={videoLink24.url}
                        title="Speaker Video"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      ></iframe>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <AllCompnayLogo />

        {/* Highlight */}
        <section className="w-full py-16 bg-cover" style={{ backgroundImage: `url('/img/home/bg-01.webp')` }}>
          <div className="w-full h-full">

            <div className="text-center pb-8">
              <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold textcolor">Highlight of Event 2025 </h1>
            </div>
            <div className="space-y-4 overflow-hidden ">
              <div className="flex space-y-10">
                <Slider  {...settingsone} className="w-full" >
                  {JsonData.awardImage24.slice(0, 10).map((awardImage24, index) => (
                    <div className='md:px-4 px-2' key={index}>
                      <img src={awardImage24.url} title='happyplus-happiness-and-wellbeing-event-photo' alt="happyplus-happiness-and-wellbeing-event-photo" />
                    </div>
                  ))}
                </Slider>
              </div>
              <div className="flex space-y-10">
                <Slider  {...settingsthree} className="w-full" >
                  {JsonData.awardImage24.slice(10, 20).map((awardImage24, index) => (
                    <div className='md:px-4 px-2' key={index}>
                      <img src={awardImage24.url} title='happyplus-happiness-and-wellbeing-event-photo' alt="happyplus-happiness-and-wellbeing-event-photo" />
                    </div>
                  ))}
                </Slider>
              </div>
              <div className="flex space-y-10">
                <Slider  {...settingstwo} className="w-full" >
                  {JsonData.awardImage24.slice(20, 30).map((awardImage24, index) => (
                    <div className='md:px-4 px-2' key={index}>
                      <img src={awardImage24.url} title='happyplus-happiness-and-wellbeing-event-photo' alt="happyplus-happiness-and-wellbeing-event-photo" />
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-cover bg-no-repeat" style={{ backgroundImage: `url('/img/home/bg-03.webp')`, }}>
          <div className="flex flex-col justify-start w-full h-full py-16 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
            <div className="mx-auto px-4 py-12 w-full">
              <div className="flex flex-col lg:flex-row">

                <div className="lg:w-1/2 flex flex-col justify-center mb-8 md:mb-0 pr-0 md:pr-8">
                  <h1 className="text-4xl md:text-5xl font-bold textcolor mb-6 leading-tight">
                    Ready to leap from feedback to action?
                  </h1>
                  <h2 className="text-2xl font-bold text-gray-800 mb-4">
                    Invest in your people today.<br />
                    If not now, when?
                  </h2>
                  <p className="text-lg text-gray-700">
                    Let's build an organization where, people feel good about how they contribute to the whole!
                  </p>
                </div>

                <ContactForm />

              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div >
    </>
  );
};

Award.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};

export default Award;
